/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPlayerPauseFilled = createReactComponent("filled", "player-pause-filled", "IconPlayerPauseFilled", [["path", { "d": "M9 4h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2z", "key": "svg-0" }], ["path", { "d": "M17 4h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2z", "key": "svg-1" }]]);

export { IconPlayerPauseFilled as default };
//# sourceMappingURL=IconPlayerPauseFilled.mjs.map
